import { render, staticRenderFns } from "./headerList.vue?vue&type=template&id=77b6b3a3&scoped=true"
import script from "./headerList.vue?vue&type=script&lang=js"
export * from "./headerList.vue?vue&type=script&lang=js"
import style0 from "./headerList.vue?vue&type=style&index=0&id=77b6b3a3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_064421c868bf9d44c080cdd6f5d40e10/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b6b3a3",
  null
  
)

export default component.exports